// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#fc127f","link":"link__U3-HW","icon":"icon__WP4Qi"};